import React, { useMemo } from 'react';
import countryList from 'react-select-country-list';
import PropTypes from 'prop-types';

import ReactSelectField from './ReactSelectField';

const CountrySelector = ({ name }) => {
  const options = useMemo(() => countryList().getData(), []);
  return (
    <ReactSelectField
      name={name}
      options={options}
      controlStyle={{ height: '3rem' }}
    />
  );
};

CountrySelector.propTypes = {
  name: PropTypes.string,
};

export default CountrySelector;
